import axios from 'axios';
import { PromoActions, PromoUsageActions } from './promoAction';
import { showSuccessSnackbar } from '../../snackBar/snackBar.action';

export const createPromoCodeAsync = (values, setShowPromoModal) => {
    return async (dispatch, getState) => {
        try {
            dispatch(PromoActions.createPromoStart());
            let { data } = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/add`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (data.statusCode === 201) {
                dispatch(PromoActions.createPromoSuccess());
                setShowPromoModal(false)
                return dispatch(showSuccessSnackbar('success', "Promo code added successfully", 3000));
            }
            dispatch(PromoActions.createPromoError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoActions.createPromoError(error?.data?.message));
            return dispatch(showSuccessSnackbar("error", error?.data?.message || "Error while adding promo. Please try again later", 3000));
        }
    }
}

export const getAllPromoCodesAsync = (params = {}) => {
    return async (dispatch, getState) => {
        try {
            const { skip, limit, searchText } = params;
            dispatch(PromoActions.getAllPromoStart());
            let { data } = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/list`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: { skip, limit, searchText }
            });
            if (data.statusCode === 200) {
                return dispatch(PromoActions.getAllPromoSuccess(data.data));
            }
            dispatch(PromoActions.getAllPromoError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoActions.getAllPromoError());
            dispatch(showSuccessSnackbar('error', "Error while fetching Data.", 3000));
        }
    }
}

export const updatePromoCodeAsync = (promoID, values, setShowPromoModal) => {
    return async (dispatch, getState) => {
        try {
            dispatch(PromoActions.updatePromoStart());
            let { data } = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/${promoID}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (data.statusCode === 200) {
                dispatch(PromoActions.updatePromoSuccess());
                setShowPromoModal(false)
                return dispatch(showSuccessSnackbar('success', "Promo code updated successfully", 3000));
            }
            dispatch(PromoActions.updatePromoError());
            return dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoActions.updatePromoError());
            dispatch(showSuccessSnackbar('error', "Error while updating. Please try again after sometime..", 3000));
        }
    }
}

export const deletePromoCodeAsync = (promoID) => {
    return async (dispatch, getState) => {
        try {
            dispatch(PromoActions.deletePromoStart());
            let { data } = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/${promoID}`,
                method: 'DELETE',
            });
            if (data.statusCode === 200) {
                dispatch(PromoActions.deletePromoSuccess());
                return dispatch(showSuccessSnackbar('success', "Promo code deleted successfully", 3000));
            }
            dispatch(PromoActions.deletePromoError());
            return dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoActions.deletePromoError());
            dispatch(showSuccessSnackbar('error', "Error while updating. Please try again after sometime..", 3000));
        }
    }
}

export const generatePromoCodesAsync = (values, setShowGenerateModal) => {
    return async (dispatch, getState) => {
        try {
            dispatch(PromoActions.createPromoStart());
            let { data } = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/generate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: values
            });
            if (data.statusCode === 201) {
                dispatch(PromoActions.createPromoSuccess());
                setShowGenerateModal(false)
                dispatch(showSuccessSnackbar('success', `Generated ${data.data.created} promo codes`, 3000));
                dispatch(getAllPromoCodesAsync());
                return;
            }
            dispatch(PromoActions.createPromoError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoActions.createPromoError(error?.data?.message));
            return dispatch(showSuccessSnackbar("error", error?.data?.message || "Error while generating promo codes. Please try again later", 3000));
        }
    }
}

export const getPromoCodeUsageStatsAsync = (promoCodeId) => {
    return async (dispatch, getState) => {
        try {
            dispatch(PromoUsageActions.getPromoUsageStart());
            let response = await axios({
                url: `${process.env.REACT_APP_HOST}${process.env.REACT_APP_BASE_URL}/promo/usage/${promoCodeId}`,
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.data.statusCode === 200) {
                return dispatch(PromoUsageActions.getPromoUsageSuccess(response.data.data));
            }
            dispatch(PromoUsageActions.getPromoUsageError());
            dispatch(showSuccessSnackbar('error', "Something went wrong!", 3000));
        } catch (error) {
            dispatch(PromoUsageActions.getPromoUsageError());
            dispatch(showSuccessSnackbar('error', "Error while fetching usage data.", 3000));
        }
    }
} 